module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/新闻资讯banner.5665c8cc.png";